export const TYPE_INTERNAL = 'internal';
export const TYPE_EXTERNAL = 'external';
export const TYPE_BOARD_MEMBER = 'board_member';

export const STATUS_ACCEPTED = 2;



// WEBPACK FOOTER //
// ./src/constants/reviewers.js